import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'split-doughnut',
  templateUrl: './split-doughnut.component.html',
  styleUrls: ['./split-doughnut.component.scss']
})
export class SplitDoughnutComponent implements OnInit {

  options: any;

  plugins: any =  [];

  schemaData: any;


  @Input() labels: Array<String> | String = [];

  @Input() data: Array<number> | number = [];
  @Input() color: Array<String> | String = ["#0A8300", "#DDD"];


  @Input() type: "NUMBER"|"PERCENTAGE" = "PERCENTAGE";




  ngOnInit() {

      if(this.type == "PERCENTAGE") {
        this.schemaData = {
          labels: this.labels,
          datasets: [
            {
                data: this.data,
                backgroundColor: this.color,
                borderWidth: [0, 0]
            }
          ]
        }
      } else {
        this.schemaData = {
          labels: [this.labels],
          datasets: [
            {
                data: [this.data],
                backgroundColor: [this.color],
                borderWidth: [0]
            }
          ]
        }
      }

        this.plugins = [
          {
            id: "counter",
            beforeDraw: (chart: any, args: any, options: any) => {
              const {ctx, chartArea: {top, right, bottom, left, width, height}, data} = chart;
              ctx.save();
              var fontSize = (height / 55).toFixed(2);
              const xCoor =  chart.getDatasetMeta(0).data[0].x;
              const yCoor =  chart.getDatasetMeta(0).data[0].y + (Number.parseInt(fontSize) / 2);
             
              ctx.font = `700 ${fontSize}em Poppins`
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
             
              if(this.type == "PERCENTAGE") {
                ctx.fillStyle = this.color[0];
                ctx.fillText(`${data.datasets[0].data[0]}%`, xCoor, yCoor);
              } else {
                ctx.fillStyle = this.color;
                ctx.fillText(`${data.datasets[0].data[0]}`, xCoor, yCoor);
              }
            }
          }
        ]


        this.options = {
            cutout: '85%',
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: { 
                  enabled: false
                }
            }
        };
  }
}
